import React, { useState } from 'react'
import _ from 'lodash'
import numeral from 'numeral'
import {
  Div, H4, Loading, P, SmallText, Label,
} from 'konsys-ui'
import moment from 'moment'
import 'moment-timezone'
import { useQuery } from '@apollo/react-hooks'
import {
  LargeTextWithLabel, Remark, Collapse,
  SummaryPrice, Divider, TableList, FileListWithModal,
} from '../../../components/common'
import { theme } from '../../../styles/_variables'
import { PURCHASEORDER } from '../../../constants/graph/query'
import { ITEM_STATUS, STATUSCOLORSELECTOR, STATUSTEXTSELECTOR } from '../constants'

export default ({ props }) => {
  const { loading: infoLoading, data: infoData, error: infoError } = useQuery(PURCHASEORDER, { variables: { id: props.match.params.id } })
  const [openCollapse, setOpenCollapse] = useState(true)
  if (infoLoading && _.isUndefined(infoData)) return <Loading center='true' />
  const data = infoData.PurchaseOrderInfo
  const subtotal = _.reduce(data.OrderItems, (sum, n) => sum + n.buyPrice * n.quantity, 0)
  const totalDiscount = _.reduce(data.OrderItems, (sum, n) => sum + (parseFloat(n.quantity || 1) * parseFloat(n.discount)), 0)
  const tableStyled = {
    0: {},
    1: {
      width: '50px',
    },
    2: {
      width: '100px',
    },
    3: {
      width: '80px',
    },
    4: {
      width: '100px',
    },
  }

  const headerData = [
    {
      text: 'สินค้าอื่นๆ',
    }, {
      text: 'จำนวน',
      textAlign: 'right',
    }, {
      text: 'ราคา/หน่วย',
      textAlign: 'right',
    }, {
      text: 'ส่วนลด',
      textAlign: 'right',
    }, {
      text: 'ราคารวม',
      textAlign: 'right',
    },
  ]

  const headerDataPR = [
    {
      text: 'สินค้าจาก PR',
    }, {
      text: 'จำนวน',
      textAlign: 'right',
    }, {
      text: 'ราคา / หน่วย',
      textAlign: 'right',
    }, {
      text: 'ส่วนลด',
      textAlign: 'right',
    }, {
      text: 'ราคารวม',
      textAlign: 'right',
    },
  ]

  const orderItemWithPROrder = _.filter(data.OrderItems, n => !_.isNull(n.PRItem))
  const orderItemWithOutPROrder = _.filter(data.OrderItems, n => _.isNull(n.PRItem))

  const TableListData = _.isEmpty(orderItemWithOutPROrder) ? [] : orderItemWithOutPROrder.map((v) => {
    const itemDetail = ITEM_STATUS.find(o => o.key === v.status)
    return (
      [
        {
          text: v.InventoryOption.inventory.productName,
          label: {
            text: (v.InventoryOption && v.InventoryOption.inventory)
              ? <Div>
                <SmallText display='block'><Label margin='0 4px 0 0'>Sku: </Label>{v.InventoryOption.inventory.sku}</SmallText>
                <SmallText display='block'><Label margin='0 4px 0 0'>Brand: </Label>{v.InventoryOption.inventory.brand}</SmallText>
              </Div>
              : '-',
          },
          status: _.isEmpty(itemDetail) ? {} : {
            text: itemDetail.text,
            color: itemDetail.color,
            icon: _.isUndefined(itemDetail.icon) ? null : itemDetail.icon,
          },
        },
        { text: v.quantity, textAlign: 'right' },
        { text: numeral(v.buyPrice).format('0,0.00'), textAlign: 'right' },
        { text: numeral(v.discount).format('0,0.00'), textAlign: 'right' },
        { text: numeral((v.buyPrice - v.discount) * v.quantity).format('0,0.00'), textAlign: 'right' },
      ]
    )
  })

  const TableListPRData = _.isEmpty(orderItemWithPROrder) ? [] : orderItemWithPROrder.map((v) => {
    const itemDetail = ITEM_STATUS.find(o => o.key === v.status)
    return (
      [
        {
          text: `${v.InventoryOption.inventory.productName} `,
          status: _.isEmpty(itemDetail) ? {} : {
            text: itemDetail.text,
            color: itemDetail.color,
            icon: _.isUndefined(itemDetail.icon) ? null : itemDetail.icon,
          },
          label: {
            text: `${v.PRItem.PurchaseRequest.refId}`,
            color: theme.color.black,
          },
        },
        { text: v.quantity, textAlign: 'right' },
        { text: numeral(v.buyPrice).format('0,0.00'), textAlign: 'right' },
        { text: numeral(v.discount).format('0,0.00'), textAlign: 'right' },
        { text: numeral((v.buyPrice - v.discount) * v.quantity).format('0,0.00'), textAlign: 'right' },
      ]
    )
  })

  const companyText = {
    PADOONGRICH: 'บริษัท ผดุงฤทธิ์ขนส่ง จำกัด',
    TRANSPORT: 'บริษัท ทรานสปอร์ตเตชั่น เน็ตเวิร์ค จำกัด',
  }

  return (
    <Div>
      <Div display='flex' justifyContent='space-between' alignItems='center'>
        <H4 bold color={theme.color.primaryColor}>{data.number}</H4>
        <P bold color={STATUSCOLORSELECTOR(data.status)}>{STATUSTEXTSELECTOR(data.status)}</P>
      </Div>
      <Div margin='32px 0'>
        <Div margin='0 0 16px' display='flex' alignItems='flex-start'>
          <LargeTextWithLabel margin='0 24px 0 0' title={{ text: 'บริษัท' }} content={{ text: companyText[data.companyType] }} />
          <LargeTextWithLabel margin='0 24px 0 0' title={{ text: 'วันที่สร้างใบ PO' }} content={{ text: moment(data.createdAt).format('DD/MM/YY') }} />
          <LargeTextWithLabel margin='0 24px 0 0' title={{ text: 'วันที่กำหนดส่ง' }} content={{ text: moment(data.dueDate).format('DD/MM/YY') }} />
          <LargeTextWithLabel margin='0 24px 0 0' title={{ text: 'วันที่กำหนดชำระ' }} content={{ text: moment(data.paymentDueDate).format('DD/MM/YY') }} />
          {/* <LargeTextWithLabel margin='0 24px 0 0' title={{ text: 'โกดังที่จัดส่ง' }} content={{ text: data.warehouse && `${data.warehouse.warehouseName} (${data.warehouse.warehouseCode})` }} /> */}
        </Div>
        {
          !_.isEmpty(data.files)
          && <Div display='inline-block' style={{ maxWidth: '100%', wordBreak: 'break-all' }} margin='0 0 16px'>
              <SmallText bold display='block'>เอกสาร</SmallText>
              <FileListWithModal files={data.files} />
            </Div>
        }
        <Remark description={_.isEmpty(data.remark) ? '-' : data.remark} />
      </Div>
      {
        (!_.isEmpty(TableListData) || !_.isEmpty(TableListPRData))
        && <Collapse text='รายละเอียดสินค้า' fullHeight open={openCollapse} onClick={() => setOpenCollapse(!openCollapse)}>
          <Div>
            {
              !_.isEmpty(TableListData)
              && <TableList data={TableListData} headerData={headerData} columnStyled={tableStyled} />
            }
            {
              !_.isEmpty(TableListData) && !_.isEmpty(TableListPRData) && <Divider margin='24px 0' />
            }
            {
              !_.isEmpty(TableListPRData)
              && <TableList data={TableListPRData} headerData={headerDataPR} columnStyled={tableStyled} />
            }
            <Divider margin='24px 0' />
            <SummaryPrice
              disabled
              data={{
                total: subtotal,
                shipping: {
                  value: data.deliveryCost,
                },
                discount: {
                  type: 'value',
                  value: totalDiscount,
                },
                vat: {
                  value: data.vatType === 'VAT_7' ? 7 : 0,
                },
              }}
            />
          </Div>
        </Collapse>
      }
    </Div>
  )
}
